import { personName } from './person';

/** Display name for a product seller (name first, email fallback). */
export function getSellerName(seller) {
  if (!seller) return '—';
  const name = personName(seller);
  return name !== '—' ? name : seller.email || '—';
}

/** Admin edit page for the seller account. */
export function getSellerAdminPath(seller) {
  if (!seller?.id) return null;
  if (seller.user_type === 'customer') {
    return `/customers/${seller.id}/edit`;
  }
  if (seller.is_influencer || seller.user_type === 'influencer') {
    return `/closet/influencers/${seller.id}/edit`;
  }
  return `/users/${seller.id}/edit`;
}

/** Products list filtered by seller. */
export function getSellerProductsPath(sellerId, sellerName) {
  if (!sellerId) return '/products';
  const params = new URLSearchParams({ seller_id: String(sellerId) });
  if (sellerName && sellerName !== '—') {
    params.set('seller_name', sellerName);
  }
  return `/products?${params.toString()}`;
}
